// summaryConfig.js

export const SUMMARY_PRIMARY_CONFIG = [
  {
    key: 'status',
    label: 'Status',
    format: 'text',
    emphasis: 'strong',
    toneResolver: (v) =>
      v === 'active' ? 'positive' : 'danger',
  },
  {
    key: 'profit',
    label: 'Profit',
    format: 'currency',
    emphasis: 'strong',
    toneResolver: (v) => (v >= 0 ? 'positive' : 'danger'),
  },
  {
    key: 'sales',
    label: 'Sales',
    format: 'number',
    emphasis: 'strong',
    toneResolver: () => 'positive',
  },
  {
    key: 'ad-sales',
    label: 'Ad sales',
    format: 'number',
    emphasis: 'strong',
    toneResolver: () => 'positive'
  },
  {
    key: 'refunds',
    label: 'Refunds',
    format: 'number',
    emphasis: 'strong',
    toneResolver: () => 'danger',
  },
  {
    key: 'ad-acos',
    label: 'Ad ACoS',
    format: 'percent',
    toneResolver: (v, ctx) =>
      v > 75 ? 'danger' : (v > 30 ? 'warning' : 'positive'),
  },
  {
    key: 'bsr',
    label: 'BSR',
    format: 'number',
    visibleWhen: (ctx) => ctx.isSingleAsin,
    toneResolver: () => 'neutral'
  },
];

export const SUMMARY_SECONDARY_CONFIG = [
  {
    group: 'Economy',
    items: [
      { key: 'sales', label: 'Sales', format: 'currency', toneResolver: () => 'positive' },
      { key: 'ad-cost', label: 'Ad cost', format: 'currency', toneResolver: () => 'warning' },
      { key: 'refunds', label: 'Refunds', format: 'currency', toneResolver: () => 'danger' },
      { key: 'spend', label: 'Total spend', format: 'currency', toneResolver: () => 'warning', action: { type: 'open-details', metric: 'spend' }}
    ],
  },
  {
    group: 'Traffic',
    items: [
      { key: 'sessions', label: 'Sessions', format: 'number', toneResolver: () => 'traffic' },
      { key: 'ad-clicks', label: 'Ad clicks', format: 'number', toneResolver: () => 'traffic' },
    ],
  },
  {
    group: 'efficiency',
    items: [
      { key: 'ad-ctr', label: 'Ad CTR', format: 'percent', toneResolver: () => 'efficiency' },
      { key: 'ad-cv', label: 'Ad CV', format: 'percent', toneResolver: () => 'efficiency' },
      { key: 'cv', label: 'CV', format: 'percent', toneResolver: () => 'efficiency' },
      { key: 'tacos', label: 'Total ACoS', format: 'percent', toneResolver: () => 'efficiency' },
    ],
  },
  {
    group: 'Inventory',
    items: [
      { key: 'prepinbound', label: 'Prep inbound', format: 'number', toneResolver: () => 'dark' },
      { key: 'prepstock', label: 'Prep stock', format: 'number', toneResolver: () => 'dark'},
      { key: 'inbound_awd', label: 'AWD inbound', format: 'number', toneResolver: () => 'dark' },
      { key: 'stock_awd', label: 'AWD stock', format: 'number', toneResolver: () => 'dark' },
      { key: 'inbound', label: 'inbound', format: 'number', toneResolver: () => 'dark' },
      { key: 'stock', label: 'Stock', format: 'number', toneResolver: () => 'dark'},
    ],
  },
  {
    group: 'Unit economics',
    visibleWhen: (ctx) => ctx.isSingleAsin,
    items: [
      { key: 'price', label: 'Price', format: 'currency', toneResolver: () => 'positive' },
      { key: 'cost', label: 'Cost', format: 'currency', toneResolver: () => 'warning' },
      { key: 'unit-profit', label: 'Unit profit', format: 'currency', toneResolver: () => 'dark' },
    ],
  },
  {
    group: 'Meta',
    visibleWhen: (ctx) => ctx.isSingleAsin,
    items: [
      { key: 'adcampaigns', label: 'Ad campaigns', format: 'number' },
      { key: 'opendate', label: 'Open date', format: 'date' },
    ],
  },
];
